import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconAdd = (props) => {
  props = Object.assign({viewBox: '0 0 36 36'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <path d="M18,4.3c7.5,0,13.7,6.1,13.7,13.7S25.5,31.7,18,31.7c-7.5,0-13.7-6.1-13.7-13.7S10.5,4.3,18,4.3 M18,2.3
		C9.3,2.3,2.3,9.3,2.3,18s7,15.7,15.7,15.7s15.7-7,15.7-15.7S26.7,2.3,18,2.3L18,2.3z"/>
        <g>
          <rect x="17" y="10" width="2" height="16"/>
          <rect x="10" y="17" width="16" height="2"/>
        </g>
      </g>
    </SvgIcon>
  );
};
// IconAdd = pure(IconAdd);
IconAdd.displayName = 'IconAdd';
IconAdd.muiName = 'SvgIcon';

export default IconAdd;



// WEBPACK FOOTER //
// ./src/components/Icons/IconAdd.js